export const deMeentHeightMinDoors = [
  "taatsdeur",
  "opdekdeur",
  "schuifdeur",
  "stompedeur",
  "scharnierdeur",
];

export const minHeightDeMeent = 2315;
